// const images = require('@images');

module.exports = {
  siteTitle: 'Subhendu Maji',
  tagline: 'Stay Awesome.',
  siteDescription: 'Portfolio Website',
  siteKeywords: 'subhendu, maji, subhendumaji, portfolio',
  siteUrl: 'https://subhendumaji.tech',
  siteLanguage: 'en_US',
  name: 'Subhendu Maji',
  location: 'Delhi, IN',
  email: 'subhendu17620@gmail.com',
  github: 'https://github.com/subhendu17620',
  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://linkedin.com/in/subhendu17620',
      iconName: 'linkedin',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/subhendu17620',
      iconName: 'github',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/subhendu_here_',
      iconName: 'instagram',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/subhendu__maji',
      iconName: 'twitter',
    },
  ],
};
